var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartdoorKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5263V4C12 2.89543 11.1046 2 10 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H10C11.1046 22 12 21.1046 12 20V15.6842",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7ZM8 7V9",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C7 13.6716 7.67157 13 8.5 13H19.5C20.3284 13 21 13.6716 21 14.5V14.5C21 15.3284 20.3284 16 19.5 16H8.5C7.67157 16 7 15.3284 7 14.5V14.5Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartdoorKey);
export default __webpack_public_path__ + "static/media/smartdoor_key.dac0c5b54840747c79823aa441946553.svg";
export { ForwardRef as ReactComponent };